//import {Chart} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

export class ChartsService {
    constructor() {
        // register annotations plugin
        //Chart.register(annotationPlugin);
    }

    addAnnotation(value: number, label: string, color: string, canvasId: string) { 
        let chart = window["ChartJsInterop"].BlazorCharts.get(canvasId);
        let annotation = chart.options["annotation"] ?? {};
        let annotations = annotation.annotations ?? []; 
        
        console.log(label);

        annotations.push({
            drawTime: "afterDatasetsDraw",
            type: 'line',
            value: value,
            scaleID: 'y-axis-0',
            borderColor: color,
            borderWidth: 2,
            mode: 'horizontal',
            label:
			{
				fontColor: "black",
				backgroundColor: "white",
				content: label,
				enabled: true
			}
        });

        annotation.annotations = annotations;
        chart.options["annotation"] = annotation; 

        chart.update();

        console.log("Chart found", chart);
    }
}